import { BLOCKS, Document } from '@contentful/rich-text-types';

/**
 * Process a Contentful document to handle CollapsibleText tags that may span multiple paragraphs.
 * This function identifies paragraphs with CollapsibleText tags, combines content that spans multiple paragraphs,
 * and marks processed paragraphs appropriately.
 *It returns a processed document with CollapsibleText content merged and marked
 */
export const processCollapsibleText = (document: Document): Document => {
  // Create a deep copy to avoid mutating the original
  const processedDocument = JSON.parse(JSON.stringify(document));

  if (processedDocument.content && processedDocument.content.length > 0) {
    let inCollapsibleText = false;
    let collapsibleContent = '';
    let collapsibleStartIndex = -1;
    let previewWordCount: number | undefined;

    // Find CollapsibleText spans across paragraphs
    for (let i = 0; i < processedDocument.content.length; i++) {
      const node = processedDocument.content[i];

      if (
        node.nodeType === BLOCKS.PARAGRAPH &&
        node.content &&
        node.content.length > 0
      ) {
        // Get the text content of this paragraph
        const paragraphText = node.content
          .filter((item: any) => item.nodeType === 'text')
          .map((item: any) => item.value)
          .join('');

        // Check for opening tag
        if (!inCollapsibleText && paragraphText.includes('<CollapsibleText')) {
          inCollapsibleText = true;
          collapsibleStartIndex = i;

          // Extract preview word count if present
          const previewMatch = paragraphText.match(/previewWordCount=(\d+)/);
          if (previewMatch) {
            previewWordCount = parseInt(previewMatch[1]);
          }

          // Get content after opening tag
          const startTagIndex = paragraphText.indexOf('<CollapsibleText');
          const openTagEnd = paragraphText.indexOf('>', startTagIndex) + 1;
          const content = paragraphText.substring(openTagEnd);
          collapsibleContent += content;
        }
        // Add content from paragraphs in between
        else if (
          inCollapsibleText &&
          !paragraphText.includes('</CollapsibleText>')
        ) {
          const separator = '\\n\\n';
          collapsibleContent += separator + paragraphText;
        }
        // Handle closing tag
        else if (
          inCollapsibleText &&
          paragraphText.includes('</CollapsibleText>')
        ) {
          const closeTagStart = paragraphText.lastIndexOf('</CollapsibleText>');
          const contentBeforeClose = paragraphText.substring(0, closeTagStart);
          collapsibleContent += '\\n\\n' + contentBeforeClose;

          // Mark the starting paragraph with the complete content
          if (collapsibleStartIndex >= 0) {
            processedDocument.content[collapsibleStartIndex].data = {
              ...processedDocument.content[collapsibleStartIndex].data,
              isCollapsibleText: true,
              collapsibleContent: collapsibleContent.trim(),
              previewWordCount,
            };

            // Mark paragraphs to be skipped (including this one)
            for (let j = collapsibleStartIndex + 1; j <= i; j++) {
              processedDocument.content[j].data = {
                ...processedDocument.content[j].data,
                skipRendering: true,
              };
            }
          }

          // Reset for next CollapsibleText
          inCollapsibleText = false;
          collapsibleContent = '';
          collapsibleStartIndex = -1;
          previewWordCount = undefined;
        }
      }
    }
  }

  return processedDocument;
};
